module.exports = __webpack_public_path__ + "static/media/pagarme.906f19a1.jpg";